import { useState, Fragment } from 'react'
import classNames from 'classnames'
import cx from 'classnames'
import { useStores } from 'hooks/useStores'
import truncate from 'lodash/truncate'
import { observer } from 'mobx-react'
import { Link } from 'react-router-dom'
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap'
import Avatar from 'components/Avatar'
import { S3FileTypeEnum } from 'constants/aws'
import routes from 'routes'
import { getS3FileUrl } from 'utils/images'
import { getName, getRole } from './utils'
import styles from './styles.module.scss'

interface IProfileMenuItem {
  label: string
  icon: string
  redirectTo?: string
}

interface IProfileDropdownProps {
  menuItems: IProfileMenuItem[]
}

const ProfileDropdown = (props: IProfileDropdownProps) => {
  const { authStore } = useStores()
  const { userDetail } = authStore
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const imageUrl = userDetail?.image
    ? getS3FileUrl(S3FileTypeEnum.IMAGE, userDetail?.organizationId ?? 0, userDetail.image)
    : ''
  const role = getRole(userDetail?.authRoleId)
  const name = getName(userDetail)

  function toggleDropdown(): void {
    setIsDropdownOpen(!isDropdownOpen)
  }

  return (
    <Dropdown className={styles.dropdown} isOpen={isDropdownOpen} toggle={toggleDropdown}>
      <DropdownToggle
        data-toggle="dropdown"
        tag="button"
        className={classNames('nav-link nav-user arrow-none mr-0', styles.dropdownToggle)}
        onClick={toggleDropdown}
        aria-expanded={isDropdownOpen}
      >
        <span className="account-user-avatar">
          <Avatar src={imageUrl} name={name} />
        </span>
        <span>
          <span className="account-user-name">{truncate(name, { length: 13 })}</span>
          <span className="account-position">{role}</span>
        </span>
      </DropdownToggle>
      <DropdownMenu right className="dropdown-menu-animated topbar-dropdown-menu profile-dropdown">
        <div onClick={toggleDropdown}>
          <div className="dropdown-header noti-title">
            <h6 className="text-overflow m-0">Welcome !</h6>
          </div>
          {props.menuItems.map((item, i) => {
            return (
              <Fragment key={i}>
                {item?.redirectTo ? (
                  <Link to={item?.redirectTo} className="dropdown-item notify-item" key={i + '-profile-menu'}>
                    <i className={`${item.icon} mr-1`}></i>
                    <span>{item.label}</span>
                  </Link>
                ) : (
                  <div
                    className={cx('dropdown-item notify-item', styles.pointer)}
                    key={i + '-profile-menu'}
                  >
                    <i className={`${item.icon} mr-1`}></i>
                    <span>{item.label}</span>
                  </div>
                )}
              </Fragment>
            )
          })}
          <Link
            to={routes.logout.value}
            className="dropdown-item notify-item"
            key={'logout-profile-menu'}
            onClick={e => {
              e.preventDefault()
              authStore.logout()
            }}
          >
            <i className={`uil uil-exit mr-1`}></i>
            <span>Logout</span>
          </Link>
        </div>
      </DropdownMenu>
    </Dropdown>
  )
}

export default observer(ProfileDropdown)
